<script>
  export let paxbotOpen = true;
  export let heading = "Define Heading";
  export let hideText= false;

  import { fly, fade } from "svelte/transition";
  function togglePaxbot() {
    paxbotOpen = !paxbotOpen;
  }
</script>

{#if paxbotOpen === true}
  <div class="paxbot_wrapper">
    {#if hideText === false}
    <div in:fade={{ delay: 400 }} out:fade class="content">
      <div class="heading">
        <div class="text bold">{heading}</div>
        <button on:click={togglePaxbot} class="close">
          <img src="/img/assistant/icons/close.svg" alt="" />
        </button>
      </div>
      <div class="chat">
        <div class="symbol">
          <img src="/img/assistant/paxbot_chatsymbol.svg" alt="chatbot" />
        </div>
        <div class="paxbot_message">
          <div class="bold">Paxbot</div>
          <slot />
        </div>
      </div>
      
    </div>
    {/if}
    <div class="paxbot">
      {#if hideText === false}
      <div in:fade={{ delay: 400 }} out:fade class="arrow">
        <img class="arrow" src="/img/assistant/paxbot_arrow.svg" alt="" />
      </div>
      {/if}
      <div in:fly={{ x: 20 }} out:fly={{ x: 20, delay: 400 }} class="portrait">
        <img src="/img/assistant/paxbot_portrait.png" alt="paxbot" />
      </div>
    </div>
  </div>
{/if}

<style>
  .paxbot_wrapper {
    position: absolute;
    right: 1rem;
    bottom: 0;
    display: flex;
    flex-direction: column;
    z-index: 30;
    justify-content: flex-end;
    align-items: flex-end;
  }

  .content {
    display: flex;
    flex-direction: column;
    background: var(--brand-gradient-topdown);
    color: white;
    border-radius: 0.5rem;
    padding: 1rem;
    gap: 1rem;
  }

  .heading {
    display: flex;
    border-bottom: 1px solid white;
    padding-bottom: 1rem;
  }

  .chat {
    display: flex;
    gap: 0.5rem;
    max-height: 600px;
    overflow: hidden;
  }

  .symbol {
    display: flex;
    gap: 0.5rem;
  }

  .symbol img {
    height: 1rem;
  }

  .paxbot_message {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    max-width: min(500px, 30vw);
    max-height: 100%;
    overflow-y: auto
  }

  .paxbot_message::-webkit-scrollbar {
    width: 0; 
    height: 0;
  }

  .paxbot {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-right: 1rem;
    gap: 0.5rem;
  }

  .arrow {
    height: 2rem;
  }

  .portrait {
    height: 100px;
  }

  .arrow img,
  .portrait img {
    max-height: 100%;
    height: 100%;
    width: auto;
  }

  .heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .close {
    height: 1rem;
    width: 1rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
